// React
import { useContext, useState } from "react"

// Components
import { DateInput } from "components"

// Contexts
import { DisabledContext } from "../contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

export function Date(params: {
  disabled?: boolean
  name: string
}) {
  // Hooks
  const disabled = useContext(DisabledContext)

  // Form
  const { control } = useFormContext()

  // State
  const [rawError, setRawError] = useState<string>("")

  return (
    <Controller
      control={control}
      name={params.name}
      render={({ field, fieldState }) => (
        <DateInput
          label="DATE"
          disabled={params.disabled || disabled}
          error={rawError || fieldState.error?.message}
          selected={moment(field.value).toDate()}
          onChange={(date) => {
            if (!date) return
            setRawError("")
            field.onChange(moment(date).format("YYYY-MM-DD"))
          }}
          onChangeRaw={(e) => {
            const raw = (e.target as HTMLInputElement).value
            if (raw && !/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
              setRawError("Format tanggal tidak valid (dd/MM/yyyy)")
            } else {
              setRawError("")
            }
          }}
        />
      )}
    />
  )
}